import { render, staticRenderFns } from "./Collapsible.vue?vue&type=template&id=0ba3e21f&"
import script from "./Collapsible.vue?vue&type=script&lang=js&"
export * from "./Collapsible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports